import { NgModule }         from '@angular/core';
import { CommonModule }     from '@angular/common';
import { MaterialModule }   from '@angular/material';
import { ResultsComponent } from './results.component';
import { FilterComponent }  from './filter.component';
import { DocumentViewerModule } from '../document-viewer/document-viewer.module';
import { CustomPipesModule } from '../custom-pipes/custom-pipes.module';
import { ContextMenuModule } from '../context-menu/context-menu.module';

@NgModule({
  imports:      [ CommonModule, MaterialModule, DocumentViewerModule, CustomPipesModule, ContextMenuModule ],
  declarations: [ ResultsComponent, FilterComponent ],
  exports:      [ ResultsComponent ]
})
export class ResultsModule {  }

